import React from 'react'

const ArrowUp: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      className="w-3 h-3 md:w-6 md:h-6"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9998 13.6667L10.9998 5.66667L2.99984 13.6667L0.33317 11L10.9998 0.33334L21.6665 11L18.9998 13.6667Z"
        fill="#333333"
      />
    </svg>
  )
}

export default ArrowUp
